import { render, staticRenderFns } from "./targetDetail.vue?vue&type=template&id=44212635"
import script from "./targetDetail.vue?vue&type=script&lang=js"
export * from "./targetDetail.vue?vue&type=script&lang=js"
import style0 from "./targetDetail.vue?vue&type=style&index=0&id=44212635&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports